interface FileChunkReadParams {
  uri: string;
  index: number;
  fileSize: number;
  chunkSize: number;
}

export function getWebChunk(params: FileChunkReadParams): Promise<ArrayBuffer> {
  const start = params.index * params.chunkSize;
  const end = Math.min((params.index + 1) * params.chunkSize, params.fileSize) - 1;

  return fetch(params.uri, {headers: {Range: `bytes=${start}-${end}`}}).then((response) =>
    response.arrayBuffer()
  );
}
